import { LoadingStates } from '@pb/utils'
import { createReducer } from 'redux-act'

import actions from './actions'
import initialState from './initialState'

const registerLoading = (state): any => ({
  ...state,
  registerFormStatus: LoadingStates.Loading,
})

const registerSuccess = (state, redirect): any => ({
  ...state,
  redirectUrl: redirect,
  registerFormStatus: LoadingStates.LoadedSuccess,
})

const registerErrors = (state, errors): any => ({
  ...state,
  registerFormStatus: LoadingStates.LoadedFail,
  registerFormErrors: errors,
})

const additionalInfoAdded = (state, data): any => ({
  ...state,
  shouldShowAdditionalInfoConsent: data,
})

export default createReducer((on) => {
  on(actions.loading, registerLoading)
  on(actions.success, registerSuccess)
  on(actions.errors, registerErrors)
  on(actions.additionalInfoAdded, additionalInfoAdded)
}, initialState)
